import { render, staticRenderFns } from "./DatabaseRequestView.vue?vue&type=template&id=dcd3d462"
import script from "./DatabaseRequestView.vue?vue&type=script&lang=js"
export * from "./DatabaseRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports